/*
 * @Author: your name
 * @Date: 2021-01-25 13:38:10
 * @LastEditTime: 2021-09-19 14:37:20
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \dhr_frontend\src\routes\modules\achievements.js
 */
export default [
  {
    name: "indexDatabase",
    path: "/achievements/index-database",
    component: () =>
      import("@/views/achievements/indexDatabase/indexDatabase.vue"),
    meta: {
      title: "指标库",
    },
  },
  {
    name: "achievementsPlan",
    path: "/achievements/achievements-plan",
    component: () => import("@/views/achievements/achievementsPlan/index.vue"),
    meta: {
      title: "绩效方案",
    },
  },
  {
    name: "achievementsActivity",
    path: "/achievements/achievements-activity",
    component: () =>
      import(
        "@/views/achievements/achievementsActivity/achievementsActivity.vue"
      ),
    meta: {
      title: "绩效活动",
    },
  },
  {
    name: "activeProgress",
    path: "/achievements/active-Progress",
    component: () =>
      import("@/views/achievements/achievementsActivity/activeProgress.vue"),
    meta: {
      parentAuth: "/achievements/achievements-activity",
      title: "查看绩效活动",
    },
  },
  {
    name: "achievementsRank",
    path: "/achievements/achievements-rank",
    component: () =>
      import(
        "@/views/achievements/achievementsRank/index.vue"
      ),
    meta: {
      title: "绩效排名",
    },
  },
  {
    name: "achievementExamine",
    path: "/achievements/achievement-examine",
    component: () =>
      import(
        "@/views/achievements/achievementsActivity/achievementExamine.vue"
      ),
    meta: {
      parentAuth: "/achievements/achievements-activity",
      title: "绩效管理员审核",
    },
  },
  {
    name: "achievementGroup",
    path: "/achievements/achievement-group",
    component: () => import("@/views/achievements/achievementGroup/index.vue"),
    meta: {
      title: "绩效分组",
    },
  },
  {
    name: "forcedDistribution",
    path: "/achievements/forced-distribution",
    component: () =>
      import(
        "@/views/achievements/achievementConfigure/forcedDistribution.vue"
      ),
    meta: {
      title: "强制分布",
    },
  },
  {
    name: "achievementsOtherSetting",
    path: "/achievements/other-setting",
    component: () =>
      import("@/views/achievements/achievementConfigure/otherSetting.vue"),
    meta: {
      title: "其他设置",
    },
  },
  {
    name: "achievementsArchives",
    path: "/achievements/achievements-archives",
    component: () =>
      import(
        "@/views/achievements/achievementsArchives/achievementsArchives.vue"
      ),
    meta: {
      title: "绩效档案",
    },
  },
  {
    name: 'achievementsInterview',
    path: '/achievements/achievements-interview',
    component: () => import('@/views/achievements/achievementsInterview/index.vue'),
    meta: {
      title: '绩效面谈'
    }
  },
];
